import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import SideBar from '../components/sideBar';
import Modal from '../components/Modal';
import '../assets/css/projectDetail.css';

const ProjectDetailScreen = () => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const db = getFirestore(getApp());
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      const projectDoc = await getDoc(doc(db, 'Projects', projectId));
      if (projectDoc.exists()) {
        setProject(projectDoc.data());
      } else {
        console.error('Project not found');
      }
    };

    fetchProject();
  }, [db, projectId]);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <div className="project-detail-container">
      <button
        onClick={toggleSidebar}
        className={`toggle-sidebar-button ${sidebarVisible ? 'sidebar-visible' : ''}`}
      >
        {sidebarVisible ? '\u003C' : '\u003E'}
      </button>
      <div className={`sidebar ${sidebarVisible ? 'translate-x-0' : '-translate-x-full'}`}>
        <SideBar />
      </div>
      <div className="topsideSection">
        {project.profileImage && (
          <div className="project-profile-image">
            <img src={project.profileImage} alt={project.name} />
          </div>
        )}
        <div className="leftSide">
          <h1 className="font-bold text-2xl">{project.name}</h1>
          <p>{project.description}</p>
        </div>
      </div>
      <div className="project-info">
        {project.images && project.images.length > 0 ? (
          <div className={`project-images ${project.images.length > 1 ? 'multiple-images' : 'single-image'}`}>
            {project.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`${project.name} ${index + 1}`}
                className="project-image  cursor-pointer"
                onClick={() => handleImageClick(image)}

              />
            ))}
          </div>
        ) : (
          <p>No images available</p>
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {selectedImage && <img src={selectedImage} alt="Full-size" className="full-size-image pj-image" />}
      </Modal>
    </div>
  );
};

export default ProjectDetailScreen;